module.exports = __webpack_public_path__ + "static/media/ic_video_activate.2afd5332.svg";